export default "__VITE_ASSET__rUtkU9cJ__"